import { type CheckoutChannel } from './pendoCheckoutCompleted';

const DONATE_SUBDOMAIN = 'donate';

/**
 * Normalizes a host-like input (hostname or URL) into a bare hostname.
 * Returns an empty string when the value is missing or cannot be parsed.
 */
const getNormalizedHostname = (hostname: string) => {
  const trimmedHostname = hostname.trim();
  if (!trimmedHostname) {
    return '';
  }

  try {
    const value = trimmedHostname.includes('://') ? trimmedHostname : `https://${trimmedHostname}`;
    return new URL(value).hostname;
  } catch {
    // Keep channel detection resilient to malformed values.
    return '';
  }
};

/**
 * Resolves checkout channel from hostname. 'channel' can either be 'web' or 'native'.
 * `donate.*` is treated as native-app webview traffic; all other hosts default to web.
 */
const getCheckoutTrackingChannel = (hostname?: string): CheckoutChannel => {
  const resolvedHostname =
    hostname ?? (typeof window === 'undefined' ? '' : (window.location?.hostname ?? ''));
  const [subdomain] = getNormalizedHostname(resolvedHostname).toLowerCase().split('.');

  return subdomain === DONATE_SUBDOMAIN ? 'native' : 'web';
};

export { getCheckoutTrackingChannel };
